import { Container, Content, Group, PaginationFooter } from './styles'
import { AiOutlineArrowLeft } from 'react-icons/ai'
import { useHistory, useParams } from 'react-router-dom'
import { useCallback, useEffect, useRef, useState } from 'react'
import OptionsNotebook from '../OptionsNotebook'
import Pagination from '../../../../components/PaginationOfQuestion'
import { useGetQuestionByBook } from '../../hooks/use-get-questions-by-book'
import QuestionsSummary from '../QuestionsSummary'
import { TSummaryQuestion } from '../QuestionsSummary/types'
import { animateScroll } from 'react-scroll'
import { RiArrowUpSLine } from 'react-icons/ri'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../../store/modules/rootReducer'
import { useAsyncFn, useWindowSize } from 'react-use'
import { switchColorMode } from '../../../../store/modules/theme/actions'
import { useTracking } from 'react-tracking'
import { TrackingSchemaTypes } from '../../../../tracking'
import { toast } from 'react-toastify'
import ReactDOM from 'react-dom'
import { useReactToPrint } from 'react-to-print'
import { InlineMath } from 'react-katex'
import QuestionsList from 'pages/SearchQuestions/components/QuestionsList'
import PrintPDF from 'pages/MyQuestionBooks/components/PrintPDF'
import { GET_QUESTION_BOOK_ITEMS } from 'pages/MyQuestionBooks/services'
import { GET_UNANSWERED_PAGE } from 'pages/QuestionBook/services'

const QuestionBookComponent = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { id: bookId } = useParams<{ id: string }>()
  const { swr, pagination, params } = useGetQuestionByBook(bookId)
  const { isDarkMode } = useSelector((state: RootState) => state.theme)
  const token = localStorage.getItem('token')
  const { width } = useWindowSize()
  const [tracking, setTracking] = useState({
    event: null,
    properties: {},
  })

  const { trackEvent } = useTracking()

  const isMobile = width <= 800

  const { setItemsPerPage, setOrder, itemsPerPage, order } = params

  const [fontSize, setFontSize] = useState(16)

  const [isSummaryOpen, setIsSummaryOpen] = useState(false)
  const [isVisible, setIsVisible] = useState(false)
  const [fullScreen, setFullScreen] = useState(false)
  const [key, setKey] = useState()
  const [hideTheme, setHideTheme] = useState(false)
  const [hideDetails, setHideDetails] = useState(false)
  const [openModalShortcuts, setOpenModalShortcuts] = useState<boolean>(false)
  const [mostRecent, setMostRecent] = useState<boolean>(() => {
    if (order === 'new') {
      return true
    }
    return false
  })

  const [renderPrintQuestionBook, setRenderPrintQuestionBook] = useState<boolean>(false)
  const [allQuestionBookItems, setAllQuestionBookItems] = useState([])
  const [loadingPrintPDF, setLoadingPrintPDF] = useState<boolean>(false)

  const handleScroll = useCallback(() => {
    setIsVisible(window.innerWidth <= 768 || itemsPerPage !== 1)
  }, [itemsPerPage, setIsVisible])

  const scrollToTop = useCallback(() => {
    animateScroll.scrollToTop({
      duration: 500,
      smooth: 'easeInOutQuad',
    })
  }, [])

  const onQuestionClick = (question: TSummaryQuestion) => {
    setItemsPerPage(1)
    setOrder('new')
    pagination.setPage(question.questionNumber)
    setIsSummaryOpen(false)
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [handleScroll])
  const onQuestionDelete = (question: TSummaryQuestion) => {
    const affectsPage = question.questionNumber <= pagination.active * itemsPerPage

    if (affectsPage) {
      swr.mutate()
    }
  }

  useEffect(() => {
    const handleKeyPress = (event) => {
      const letter = event.key
      if (window.innerWidth >= 1080 && itemsPerPage === 1) {
        if (letter === 'ArrowRight' || event.keyCode === 102) {
          if (pagination.active !== pagination.total) {
            pagination.next()
          }
        } else if (letter === 'ArrowLeft' || event.keyCode === 100) {
          if (pagination.active !== 1) {
            pagination.previous()
          }
        } else if (letter === 'f' || letter === 'F') {
          if (!document.fullscreenElement) {
            if (document.documentElement.requestFullscreen) {
              setFullScreen(true)
              return document.documentElement.requestFullscreen()
            }
          } else {
            if (document.exitFullscreen) {
              setFullScreen(false)
              return document.exitFullscreen()
            }
          }
        } else if (letter === 'K' || letter === 'k') {
          dispatch(switchColorMode({ isDarkMode: !isDarkMode }))
        } else if (letter === 'I' || letter === 'i') {
          setHideTheme(!hideTheme)
        }
      }
      setKey(letter)
    }
    window.addEventListener('keydown', handleKeyPress)
    return () => {
      window.removeEventListener('keydown', handleKeyPress)
    }
  }, [dispatch, hideTheme, isDarkMode, itemsPerPage, pagination])

  const [state, execute] = useAsyncFn(async () => {
    const data = await GET_UNANSWERED_PAGE(bookId, mostRecent, itemsPerPage)

    pagination.setPage(data.unansweredPage)
  }, [bookId, mostRecent, itemsPerPage, pagination, token])

  useEffect(() => {
    if (tracking.event)
      trackEvent({
        event: TrackingSchemaTypes[tracking.event],
        properties: tracking.properties,
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tracking])

  const renderSpecialCharacters = useCallback(() => {
    const optionsTags = document.getElementsByClassName(`questionOption-${swr.data.docs[0]?.code}`)
    const statementTag = document.getElementById(`question-option-${swr.data.docs[0]?.code}`)

    const elements = [...Array.from(optionsTags), statementTag].filter(Boolean)

    if (!elements.length) return

    elements.forEach((el) => {
      const htmlContent = el.innerHTML
      el.innerHTML = htmlContent.replace(/\\[n|r|t]/g, '<br>')
    })
  }, [swr.data.docs])

  const renderMathForm = useCallback(() => {
    const tags = document.getElementsByTagName('math-component')
    if (tags && tags.length) {
      for (let i = 0; i < tags.length; i++) {
        const newEl = tags[i].insertAdjacentElement('afterend', document.createElement('div'))
        newEl.id = `math${i}`
        newEl.setAttribute('style', tags[i].getAttribute('style') || '')

        const mathElem = tags[i] as HTMLDivElement

        mathElem.style.display = 'none'

        ReactDOM.render(<InlineMath math={tags[i].innerHTML} />, newEl, () => {
          if (i === tags.length - 1) {
            renderSpecialCharacters()
          }
        })
      }
    }
  }, [renderSpecialCharacters])

  const printQuestionBook = async () => {
    try {
      if (loadingPrintPDF) {
        toast.info('Aguarde o caderno ser gerado!')
        return
      }

      setLoadingPrintPDF(true)
      toast.info('Caderno sendo preparado para download, aguarde!')
      const response = await GET_QUESTION_BOOK_ITEMS(swr.data.docs[0]?.questionBook._id)

      const result = response?.map((q) => {
        const title = q.title
        const firstTag = title.indexOf('>')

        const createQuesionWithQuestionNumber =
          title.substring(0, firstTag + 1) +
          `<b>${q.questionNumber} - </b>` +
          title.substring(firstTag + 1)

        q.title = createQuesionWithQuestionNumber

        return q
      })

      setAllQuestionBookItems(result)
      setRenderPrintQuestionBook(true)
      renderMathForm()
      handlePrint()
    } catch (error) {
      console.log(error)
      toast.error('Falha ao preparar caderno para download, tente novamente')
    }
  }

  const questionBookPrintRef = useRef<HTMLDivElement>()

  const handlePrint = useReactToPrint({
    content: () => questionBookPrintRef.current,
    onAfterPrint: () => {
      setRenderPrintQuestionBook(false)
      setLoadingPrintPDF(false)
    },
    onBeforePrint: () => renderMathForm(),
    pageStyle: 'margin: 20 !important; display: flex !important',
    documentTitle: allQuestionBookItems[0]?.questionBookName,
    removeAfterPrint: false,
  })

  return (
    <>
      <Container>
        <Content>
          <Group style={{ display: fullScreen ? 'none' : 'flex' }}>
            <AiOutlineArrowLeft className="icon" onClick={history.goBack} color="#FF6600" />
            <h1 className="title">
              Caderno:{' '}
              {swr.isLoading ? (
                <div className="loading-block" />
              ) : (
                swr.data.docs[0]?.questionBook.name
              )}
            </h1>
          </Group>

          <OptionsNotebook
            itemsPerPage={itemsPerPage}
            setItemsPerPage={setItemsPerPage}
            order={order}
            setOrder={setOrder}
            setFontSize={setFontSize}
            onSummaryClick={() => setIsSummaryOpen(true)}
            setFullScreen={setFullScreen}
            fullScreen={fullScreen}
            setOpenModalShortcuts={setOpenModalShortcuts}
            openModalShortcuts={openModalShortcuts}
            onPrintClick={() => printQuestionBook()}
          />

          <PaginationFooter className="mobile">
            <Pagination
              pagination={pagination}
              bookId={bookId}
              itemsPerPage={itemsPerPage}
              unanswered={execute}
            />
          </PaginationFooter>

          <QuestionsList
            hideTheme={hideTheme}
            hideDetails={hideDetails}
            setHideTheme={setHideTheme}
            setHideDetails={setHideDetails}
            dataKey={key}
            data={swr.data.docs}
            isLoading={swr.isLoading}
            page={pagination.active}
            itemsPerPage={itemsPerPage}
            fontSize={fontSize}
            onAnswer={swr.mutate}
            isMobile={isMobile}
            unanswered={execute}
            setTracking={setTracking}
          />
        </Content>
        <PaginationFooter>
          <Pagination
            pagination={pagination}
            bookId={bookId}
            itemsPerPage={itemsPerPage}
            unanswered={execute}
          />
        </PaginationFooter>
        <div
          className={`scroll-button ${isVisible ? 'visible' : ''}`}
          onClick={scrollToTop}
          role="button"
          tabIndex={0}
        >
          {isDarkMode ? (
            <RiArrowUpSLine size={25} color="#F9F9F9" />
          ) : (
            <RiArrowUpSLine size={25} color="#394A64" />
          )}
        </div>
      </Container>
      <QuestionsSummary
        questionBookId={bookId}
        isOpen={isSummaryOpen}
        onClose={() => setIsSummaryOpen(false)}
        onQuestionClick={onQuestionClick}
        onQuestionDelete={onQuestionDelete}
      />
      {renderPrintQuestionBook && (
        <PrintPDF
          questionBookPrintRef={questionBookPrintRef}
          allQuestionBookItems={allQuestionBookItems}
        />
      )}
    </>
  )
}

export default QuestionBookComponent
